// @ts-nocheck
import type { Requests } from '../../../../base/realtime-session';
import type { MlAndAiPost } from '../../../../types/server/modules/mlAndAi/post';

export type * from '../../../../types/server/modules/mlAndAi/post';

export const createPost = ( requests: Requests ): MlAndAiPost => ({
  ai_assistant_send_message: Object.assign(( body,headers ) => {
      return requests.post( `/ai-assistant/message`, { body }, headers );
    }, { operation: 'ml-and-ai:ai-assistant-send-message', route: 'POST /ai-assistant/message', subdomain: 'ml-and-ai', visibility: 'private' } as const ),
  ai_assistant_submit_automation_request: Object.assign(( body,headers ) => {
      return requests.post( `/ai-assistant/automation-requests/submit`, { body }, headers );
    }, { operation: 'ml-and-ai:ai-assistant-submit-automation-request', route: 'POST /ai-assistant/automation-requests/submit', subdomain: 'ml-and-ai', visibility: 'private' } as const ),
  ai_assistant_feedback: Object.assign(( body,headers ) => {
      return requests.post( `/ai-assistant/feedback`, { body }, headers );
    }, { operation: 'ml-and-ai:ai-assistant-feedback', route: 'POST /ai-assistant/feedback', subdomain: 'ml-and-ai', visibility: 'private' } as const )
});
